module.exports = __webpack_public_path__ + "static/media/OPN_110.022982e3.png";